/**
 * «Avisar de un problema aquí» en la ayuda de Gavi de TODAS las pantallas
 * (Vadik, 31-oct-2026): un paso en «Cuéntame esta pantalla» que señala la
 * opción de la brújula y una pregunta más en el menú, «¿Qué hago si algo
 * falla?». Se añade aquí una vez en vez de en cada usePreguntas<X>.
 */
import type { PasoAyuda, PreguntaAyuda } from './pasos';

export type TextosProblema = {
  /** Toca la brújula (paso que espera el toque de verdad). */
  tocaBrujula: string;
  /** Lo que dice Gavi sobre la opción. */
  explica: string;
  /** La pregunta del menú. */
  pregunta: string;
};

const SELECTOR_OPCION = '[data-testid="opcion-avisar-problema"]';

function todos(selector: string): Element[] {
  return Array.from(document.querySelectorAll(selector));
}

/**
 * Las preguntas de la pantalla con el aviso de problema añadido. Sin cuenta
 * en el servidor la opción no existe en la brújula: se devuelven tal cual.
 */
export function conAvisoProblema(
  preguntas: PreguntaAyuda[],
  textos: TextosProblema,
  conCuenta: boolean,
): PreguntaAyuda[] {
  if (!conCuenta || preguntas.length === 0) {
    return preguntas;
  }
  const opcion: PasoAyuda = {
    id: 'avisar-problema',
    escena: 'brujula',
    radio: 26,
    texto: textos.explica,
    objetivo: () => todos(SELECTOR_OPCION),
  };
  const brujula: PasoAyuda = {
    id: 'brujula-problema',
    escena: 'normal',
    radio: 30,
    toque: true,
    texto: textos.tocaBrujula,
    objetivo: () => todos('[data-testid="brujula-opciones"]'),
  };

  const [recorrido, ...resto] = preguntas;
  const pasos = [...recorrido.pasos];
  const primeraBrujula = pasos.findIndex(p => p.escena === 'brujula');
  if (primeraBrujula >= 0) {
    // La opción va arriba del todo de la brújula: Gavi la cuenta la primera.
    pasos.splice(primeraBrujula, 0, opcion);
  } else {
    const ultimo = pasos.at(-1);
    pasos.splice(
      ultimo?.final ? pasos.length - 1 : pasos.length,
      0,
      brujula,
      opcion,
    );
  }

  return [
    { ...recorrido, pasos },
    ...resto,
    {
      id: 'avisar-problema',
      texto: textos.pregunta,
      pasos: [brujula, { ...opcion, final: true }],
    },
  ];
}
